import React, { ReactNode, useEffect } from 'react';
import URI from 'urijs';
import { useRouter } from 'next/router';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { TrackPage } from 'Tracking/track-page/TrackPage';
import { clearAllCacheFront } from 'Utils/graphql-client/cacheFront';
import { Layer } from 'Components/frameworks/layer/Layer';
type Props = PropsWithPageTracking<{
  children: ReactNode;
  close?: any;
  forceRefreshOnClose?: boolean;
  hasContainerHeader?: boolean;
  iconName?: string;
  name: string;
  onBack?: () => void;
  onClose?: () => void;
  params?: Array<string>; // query paramaters that will be remove when the layer close
}>;

const closeLayer = ({ cleanUrl, forceRefreshOnClose, router }) => {
  const newUri = cleanUrl(router);

  if (forceRefreshOnClose) {
    clearAllCacheFront();
    window.location = newUri;
  } else {
    router.push(newUri, undefined, {
      shallow: true,
    });
  }
};

export const ClosableLayer = (props: Props) => {
  const {
    children,
    close,
    forceRefreshOnClose,
    hasContainerHeader = true,
    iconName,
    onBack,
    params,
    tracking,
    ...layerProps
  } = props;
  const router = useRouter();
  const { openLayer } = router.query;
  const showLayer = openLayer === props.name;

  const cleanUrl = (nextRouter) => {
    return new URI(nextRouter.asPath)
      .clone()
      .removeSearch(['openLayer', ...(params || [])])
      .resource();
  };

  const onClose = () => {
    closeLayer({
      cleanUrl,
      forceRefreshOnClose,
      router,
    });

    if (props.onClose) {
      props.onClose();
    }
  };

  useEffect(() => {
    if (close) {
      close(onClose);
    }
  }, []);
  return showLayer ? (
    <Layer
      {...layerProps}
      buttonLeft={{
        iconName: iconName || ICONS.ARROW_TAIL_LEFT,
        label: t('common.close'),
        onClick: onBack || onClose,
      }}
      closeLabel={t('common.close')}
      hasContainerHeader={hasContainerHeader}
      onClose={onClose}
    >
      {tracking?.pageName && <TrackPage pageName={tracking.pageName} payload={tracking.payload} />}
      {children}
    </Layer>
  ) : null;
};
